import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { emailsService } from "@/_services";

// Add the required rule
extend('required', {
  ...required,
  message: 'This field is required'
});

// Add a rule.
extend('token-validation', {
  validate: (value, [availableTokens]) => {

    if (!Array.isArray(availableTokens)) {
      availableTokens = []
    }

    availableTokens.forEach(token => {
      if (token.token != '[my_proposition]' && token.token != '[my_website_url_tracking]') {
        let tokenData = token.token;

        tokenData = tokenData.replace("[", "").replace("]", "");
        tokenData = "\\[" + tokenData + " default=\"[\\s\\w'À-ÿ\u00f1\u00d1&;]*\"\\]";

        const regexp = new RegExp(`${tokenData}`, "g");
        value = value.replace(regexp, "");
      }
    });

    if (value.includes("[") || value.includes("]")) {
      return false;
    }

    let spintaxRegex = "\{([^\{\}\\n\\r<>]+[^\|])\}";

    const regexp = new RegExp(`${spintaxRegex}`, "g");
    value = value.replace(regexp, "");

    console.log("entro en validateTOken")
    if (value.includes("{") || value.includes("}")) {
      return false;
    }

    return true;
  },
  message: 'One or several tokens are misspelled'
});

extend('length-plain-text', {
  validate: (value, args) => {
    let regex = /(<script(\s|\S)*?<\/script>)|(<style(\s|\S)*?<\/style>)|(<!--(\s|\S)*?-->)|(<\/?(\s|\S)*?>)/g
    value = value.replace(regex, "");
    if (args[0].min != undefined && value.length < args[0].min) {
      return false;
    }
    if (args[0].max != undefined && value.length > args[0].max) {
      return false;
    }
    return true
  },
  message: (field, args, data) => {
    if (args[0].min != undefined) {
      return "Min length: " + args[0].min
    }
    if (args[0].max != undefined) {
      return "Max length: " + args[0].max
    }
  },
});

extend('hex-color', {
  validate: (value, args) => {
    let regex = /#[0-9A-Fa-f]{6,6}/g;
    if (!value.match(regex)) {
      return false
    }
    return true
  },
  message: (field, args, data) => {
    return "HEX Correct Format #123456"
  },
});

export const campaignUtilsMixin = {

  data() {
    return {
      testBusinessContactSelected: 0,
      testBusinessContact: [
        {
          '[prospect_last_name]': 'Duval',
          '[prospect_first_name]': 'Frédéric',
          '[prospect_city]': 'Montpellier',
          '[prospect_website_url]': 'https://abcconseil.fr/',
          '[prospect_company_name]': 'ABC Conseil',
          '[gender]': 'Mr',
          '[prospect_job_title]': 'CEO',
          '[product_market_area]': 'France',
          '[product_year_start]': '2015',
          '[product_name]': 'OliverList',
          '[we_propose]': 'nous générons pour vous et votre équipe des rendez-vous qualifiés, directement dans vos agendas',
          '[we_are_convinced]': 'grâce à notre solution, vos commerciaux pourraient enfin se concentrer sur qu’ils aiment faire : vendre',
          '[in_few_words]': 'nous vous permettons de déléguer votre prospection à des experts, tout en ne prenant aucun risque',
          '[we_wanted_to_exchange_about]': 'les objectifs commerciaux que vous avez fixés pour le prochain semestre',
          '[the_idea_is_simple]': 'libérer vos équipes commerciales du travail long et rébarbatif de prospection',
          '[we_were_wondering_how]': 'vous assuriez un flux constant de rendez-vous qualifiés pour vos commerciaux',
          '[what_we_created]': 'une plateforme vous permettant de commander des rendez-vous qualifiés B2B en quelques clics',
          '[prospect_area]': 'commerciaux',
          '[argument_1]': 'Remplir l\'agenda de vos commerciaux avec des rendez-vous B2B qualifiés',
          '[argument_2]': 'Payer uniquement les rendez-vous qualifiés',
          '[argument_3]': 'Ne pas avoir à vous engager sur le long terme',
          '[ref_1]': 'Paytweak',
          '[ref_2]': 'Expensya',
          '[ref_3]': 'Casino',
          '[custom_sentence]': 'Je souhaitais enfin ajouter que vous pouvez essayer la plateforme sans engagement',
        }, {
          '[prospect_last_name]': 'Caral',
          '[prospect_first_name]': 'Céline',
          '[prospect_city]': 'Paris',
          '[prospect_website_url]': 'https://www.lvmh.fr/',
          '[prospect_company_name]': 'LVMH',
          '[gender]': 'Mme',
          '[prospect_job_title]': 'Directrice Marketing',
          '[product_market_area]': 'Île-de-france',
          '[product_year_start]': '2012',
          '[product_name]': 'Les Rois',
          '[we_propose]': 'nous vous offrons le meilleur service pour votre communication par le textile personnalisé',
          '[we_are_convinced]': 'notre atelier de merchandizing serait le meilleur choix pour votre entreprise. Nous cherchons toujours la fierté des collaborateurs de nos clients avec du textile de qualité sur mesure',
          '[in_few_words]': 'nous créons des textiles brandés avec le logo de votre entreprise 100 % Made in France.',
          '[we_wanted_to_exchange_about]': 'votre stratégie de branding en interne',
          '[the_idea_is_simple]': 'rendre les projets de merchandising, faciles, transparents et le plus responsable possible',
          '[we_were_wondering_how]': 'si vous proposiez du textile 100% made in France et brandé à l\'effigie de votre entreprise à vos collaborateurs ?',
          '[what_we_created]': 'un marque de merchandizing qui casse les codes, avec plus d\'humain et de la proiduction 100% francaise',
          '[prospect_area]': 'Marketing',
          '[argument_1]': 'vous donner de la visibilité',
          '[argument_2]': 'fédérer vos équipes',
          '[argument_3]': 'montrer à vos clients que vous les aimez',
          '[ref_1]': 'Bouygues Construction',
          '[ref_2]': 'Naval Groupe',
          '[ref_3]': 'Orano',
          '[custom_sentence]': 'Déjà 344 entreprises nous font confiance',
        }, {
          '[prospect_last_name]': 'Mary',
          '[prospect_first_name]': 'Pierre-Auguste',
          '[prospect_city]': 'Nantes',
          '[prospect_website_url]': 'https://www.generali.fr/',
          '[prospect_company_name]': 'Generali',
          '[gender]': 'Mr',
          '[prospect_job_title]': 'Chef de projet',
          '[product_market_area]': 'France',
          '[product_year_start]': '2013',
          '[product_name]': 'Le Cocon',
          '[we_propose]': 'nous accompagnons les équipes commerciales d\'Amazon, Backmarket, La Banque Postale, IDEMIA, Aircall, Ionos... à tirer le meilleur de l\'automatisation sur LinkedIn à travers une formation actionnable et financable',
          '[we_are_convinced]': 'nous pouvons tirer beaucoup de vote réseau. Je dis cela car nous formons des profils très similaires au votre et je pourrais vous donner de nombreux exemples pour qui la maitrise de ce canal a été primordial',
          '[in_few_words]': 'nous accompagnons les équipes de commerciaux à tirer le meilleur parti de l\'automatisation de LinkedIn grâce à des formations pratiques et abordables.',
          '[we_wanted_to_exchange_about]': 'la manière dont vous ou vos équipes commerciales maîtrisez le canal d\'acquisition LinkedIn',
          '[the_idea_is_simple]': 'vous procurer une remise à niveau rapide et efficace sur les bonnes pratiques à mettre en place sur le canal d\'acquisition LinkedIn',
          '[we_were_wondering_how]': 'si vous pensiez que vous équipes commerciales maitrise LinkedIn en tant que vecteur de business ?',
          '[what_we_created]': 'un formateur spécialisé sur l\'acquisition de nouveaux clients/prospects grâce à LinkedIn',
          '[prospect_area]': 'Commerciale',
          '[argument_1]': 'vous apprendre à générer de 5 à 10 rendez-vous qualifiés par mois et par commerciaux',
          '[argument_2]': 'tirer le meilleur de votre profil LinkedIn',
          '[argument_3]': 'générer des rendez-vous en automatique',
          '[ref_1]': 'Nestlé',
          '[ref_2]': 'Crédit Agricole',
          '[ref_3]': 'Akka Technologie',
          '[custom_sentence]': 'Avec la bonne formation, vous ou vos commerciaux pourriez obtenir les mêmes résultats, d\'autant plus que celle que je vous propose est finançable à 100% par l\'état (OPCO, CPF...)',
        }, {
          '[prospect_last_name]': 'Depradeux',
          '[prospect_first_name]': 'Erica',
          '[prospect_city]': 'Orléans',
          '[prospect_website_url]': 'https://www.avenirradio.com/',
          '[prospect_company_name]': 'Avenir Radio',
          '[gender]': 'Mme',
          '[prospect_job_title]': 'Présidente',
          '[product_market_area]': 'Paris',
          '[product_year_start]': '2014',
          '[product_name]': 'Rainbow Kitchen',
          '[we_propose]': 'nous proposons des brunch au bureau,des lunch box,des buffets et même des ateliers qui ont tous un point commun : une cuisine colorée et festive',
          '[we_are_convinced]': 'nos compositions plairons à vos collaborateurs lors de votre prochain événement',
          '[in_few_words]': 'nous proposons un service de traiteur composé de produits bios et végétariens. Nos offres sont 100% personnalisables et abordables.',
          '[we_wanted_to_exchange_about]': 'les évènements que vous organisez dans votre entreprise',
          '[the_idea_is_simple]': 'libérer vos équipes commerciales du travail rébarbatif de prospection commerciale',
          '[we_were_wondering_how]': 'si vous aviez déjà eu l\'occasion d\'organiser des buffets ou des ateliers de découverte culinaires ?',
          '[what_we_created]': 'un service de traiteur spécialisé dans les produits fais de saison',
          '[prospect_area]': 'marketing',
          '[argument_1]': 'proposer un buffet avec des produits frais',
          '[argument_2]': 'proposer un buffet avec des produits de saison uniquemet',
          '[argument_3]': 'proposer un buffet avec des produits bios',
          '[ref_1]': 'Danone',
          '[ref_2]': 'le Petit Paumé',
          '[ref_3]': 'Mega',
          '[custom_sentence]': 'Je voulais aussi partager un info importante : 98% des collaborateurs de nos clients sont fiers que leur entreprise propose des buffets de produit frais et de saison lors des évênemets corporates',
        }, {
          '[prospect_last_name]': 'Bansilhon',
          '[prospect_first_name]': 'Pierre',
          '[prospect_city]': 'Royan',
          '[prospect_website_url]': 'https://www.btsconstruction.com/',
          '[prospect_company_name]': 'BTS Construction',
          '[gender]': 'Mr',
          '[prospect_job_title]': 'Assistant de direction',
          '[product_market_area]': 'Allemagne',
          '[product_year_start]': '2015',
          '[product_name]': 'Growth Room',
          '[we_propose]': 'nous aidons les marques à générer de nouveaux prospects en ligne à l’aide de campagnes de publicité en ligne : pour obtenir de nouveaux prospects dès la semaine prochaine',
          '[we_are_convinced]': 'nous pouvons optimiser de manière importante les résultats de vos campagnes de prospection, taux cannaux confondus',
          '[in_few_words]': 'nous proposons des services de publicité en ligne avec ROI garanti',
          '[we_wanted_to_exchange_about]': 'la production de contenus vidéos à re-utiliser dans votre communication',
          '[the_idea_is_simple]': 'libérer vos équipes commerciales du travail rébarbatif de prospection commerciale',
          '[we_were_wondering_how]': 'quel volume de prospects vous arriviez à générer chaque semaine avec celui-ci',
          '[what_we_created]': 'la première application de vote électronique sécurisée par la blockchain, permettant de simplifier le dialogue et les votes en assemblée générale',
          '[prospect_area]': 'administratif',
          '[argument_1]': 'remplir l\'agenda de vos commerciaux avec des rendez-vous B2B',
          '[argument_2]': 'payer uniquement pour des rendez-vous avec des prospects présents dans votre cible',
          '[argument_3]': 'payer uniquement pour des rendez-vous effectués',
          '[ref_1]': 'Paytweak',
          '[ref_2]': 'N2F',
          '[ref_3]': 'Expensya',
          '[custom_sentence]': 'Par ailleurs, je suis certain que vous n’avez pas le temps de rédiger des dizaines d’articles pour vous permettre à votre site de gagner en visibilité',
        }, /*{
          '[prospect_last_name]': 'Lemens',
          '[prospect_first_name]': 'Nicolas',
          '[prospect_city]': 'Bordeaux',
          '[prospect_website_url]': 'https://www.ayena.io/',
          '[prospect_company_name]': 'Ayena',
          '[gender]': 'Mr',
          '[prospect_job_title]': 'Founder',
          '[product_market_area]': 'Pologne',
          '[product_year_start]': '2016',
          '[product_name]': 'Enerbat',
          '[we_propose]': 'nous proposons une solution permettant de remplir l\'agenda de vos commerciaux avec des rendez-vous qualifiés',
          '[we_are_convinced]': '',
          '[in_few_words]': 'cette solution divise les coûts par 2 et le temps passé à la gestion de votre flotte par 6.',
          '[we_wanted_to_exchange_about]': 'la mise en conformité au RGPD en interne',
          '[the_idea_is_simple]': '',
          '[we_were_wondering_how]': 'si vous aviez l’habitude de célébrer vos opérations et deals avec la création de tombstones personnalisés',
          '[what_we_created]': 'notre agence de génération de leads B2B pour vos commerciaux',
          '[prospect_area]': '',
          '[argument_1]': 'former vos équipes pour qu’ils puissent créer leurs propres outils interne',
          '[argument_2]': '',
          '[argument_3]': '',
          '[ref_1]': '',
          '[ref_2]': '',
          '[ref_3]': '',
          '[custom_sentence]': '',
        }, {
          '[prospect_last_name]': 'Chaumon',
          '[prospect_first_name]': 'Naik',
          '[prospect_city]': 'Marseille',
          '[prospect_website_url]': 'https://ncd.it/',
          '[prospect_company_name]': 'NCD Patrimoine',
          '[gender]': 'Mr',
          '[prospect_job_title]': 'Co-Founder',
          '[product_market_area]': 'Mexique',
          '[product_year_start]': '2017',
          '[product_name]': 'Rainbow Kitchen',
          '[we_propose]': '',
          '[we_are_convinced]': '',
          '[in_few_words]': '',
          '[we_wanted_to_exchange_about]': 'la manière dont vous gérez l’ensemble des thématiques patrimoniales',
          '[the_idea_is_simple]': '',
          '[we_were_wondering_how]': 'comment vous assurez vous d\'un flux constant de rendez-vous qualifiés pour vos commerciaux',
          '[what_we_created]': '',
          '[prospect_area]': '',
          '[argument_1]': 'économiser 80% du temps dédié à l’organisation et au suivi de vos AG',
          '[argument_2]': '',
          '[argument_3]': '',
          '[ref_1]': '',
          '[ref_2]': '',
          '[ref_3]': '',
          '[custom_sentence]': '',
        }, {
          '[prospect_last_name]': 'Minas',
          '[prospect_first_name]': 'Mathieu',
          '[prospect_city]': 'Toulon',
          '[prospect_website_url]': 'https://picky.com/',
          '[prospect_company_name]': 'Picky Spring',
          '[gender]': 'Mr',
          '[prospect_job_title]': 'PDG',
          '[product_market_area]': 'Catalogne',
          '[product_year_start]': '2018',
          '[product_name]': '',
          '[we_propose]': '',
          '[we_are_convinced]': '',
          '[in_few_words]': '',
          '[we_wanted_to_exchange_about]': 'la manière dont vous gérez le pilotage social pour le service RH et répondez aux obligations sociales pour votre CSE (Index d\'égalité et BDESE)',
          '[the_idea_is_simple]': '',
          '[we_were_wondering_how]': '',
          '[what_we_created]': '',
          '[prospect_area]': '',
          '[argument_1]': 'remplir l\'agenda de vos commerciaux avec des rendez-vous B2B',
          '[argument_2]': '',
          '[argument_3]': '',
          '[ref_1]': '',
          '[ref_2]': '',
          '[ref_3]': '',
          '[custom_sentence]': '',
        },*/
      ],
    }
  },
  methods: {
    replaceSpintax(txt) {
      const pattern = /\{([^\{\}\n\r<>]+[^\|])\}/i;

      let match;
      while ((match = pattern.exec(txt)) !== null) {
        console.log({ match })
        const shortcode = match[0];
        const options = match[1].split("|");
        const countOpt = options.length - 1;

        const pos = Math.floor(Math.random() * (countOpt + 1));
        const uniqueOpt = options[pos];

        txt = txt.replace(shortcode, uniqueOpt);
      }

      return txt;
    },

    checkAvailableTokens: function (message) {
      let tokens = this.availableTokens;

      if (!Array.isArray(tokens)) {
        tokens = []
      }

      let i = 0;
      for (i = 0; i < tokens.length; i++) {
        let tokenData = tokens[i].token;

        tokenData = tokenData.replace('[', '\\[').replace(']', '\\]');
        const regexp = new RegExp(`${tokenData}`, 'g')
        message = message.replace(regexp, "");
      }
      if (message.includes("[") || message.includes("]")) {
        return false;
      }

      return true;
    },

    formatTokens: function (message) {
      let tokens = this.availableTokens;

      if (!Array.isArray(tokens)) {
        tokens = []
      }

      let i = 0;

      for (i = 0; i < tokens.length; i++) {
        let token = tokens[i].token;
        let tokenType = tokens[i].type;

        tokenData = token.replace("[", "").replace("]", "");
        tokenData = "\\[" + tokenData + "( default=\"[\\s\\w'À-ÿ\u00f1\u00d1&;]*\")?\\]";
        const regexp = new RegExp(`${tokenData}`, "g");
        message = message.replace(regexp, "<span class=\"token " + tokenType + "\">" + token + "</span>");
      }

      let tokenData = '[my_proposition]'.replace('[', '\\[').replace(']', '\\]');
      const regexp = new RegExp(`(${tokenData})`, 'g')

      if (this.model.campaign.tpl_first_step != undefined && this.model.campaign.tpl_first_step.service !== undefined && this.model.campaign.tpl_first_step.service !== '') {
        message = message.replace(regexp, this.model.campaign.tpl_first_step.service);
      }

      let campaignTokens = this.model.campaignTokens
      // console.log("ddd", this.model.campignTokens)

      let contact = this.testBusinessContact[this.testBusinessContactSelected];

      tokens.forEach(token => {
        let tokenData = token.token.replace("[", "").replace("]", "");
        if (campaignTokens[tokenData] !== undefined && campaignTokens[tokenData].value != token.token && campaignTokens[tokenData].value !== null) {
          contact[token.token] = campaignTokens[tokenData].value
        }
      });

      if (this.model.campaign.demo_url !== undefined && contact['[my_website_url_tracking]'] == undefined) {
        contact['[my_website_url_tracking]'] = this.model.campaign.demo_url;
      }
      if (this.currentUser.name !== undefined && contact['[my_first_name]'] == undefined) {
        contact['[my_first_name]'] = this.model.campaign.conn_first_name != undefined ? this.model.campaign.conn_first_name : this.currentUser.name;
      }
      if (this.currentUser.lastname !== undefined && contact['[my_last_name]'] == undefined) {
        contact['[my_last_name]'] = this.model.campaign.conn_last_name != undefined ? this.model.campaign.conn_last_name : this.currentUser.lastname;
      }
      if (this.currentUser.client_name !== undefined && contact['[my_company_name]'] == undefined) {
        contact['[my_company_name]'] = this.currentUser.client_name;
      }
      if (contact['[my_calendar_link]'] == undefined) {
        contact['[my_calendar_link]'] = "https://aivoni.com/calendar";
      }

      for (const [key, value] of Object.entries(contact)) {
        let tokenData = key;
        tokenData = tokenData.replace('[', '\\[').replace(']', '\\]');
        const regexp = new RegExp(`(${tokenData})`, 'g')
        message = message.replace(regexp, value);
      }

      message = this.replaceSpintax(message);

      return message;
    },

    formatTokensAgency: function (message, datatoken = null, textTooltip = null) {
      if (typeof datatoken === "string") {
        if (datatoken !== '') {
          datatoken = JSON.parse(datatoken)
        } else {
          datatoken = null
        }
      }

      let tokens = this.availableTokens;

      if (!Array.isArray(tokens)) {
        tokens = []
      }

      let i = 0;

      for (i = 0; i < tokens.length; i++) {
        let token = tokens[i].token;
        let tokenName = token.replace("[", "").replace("]", "");
        let tokenType = tokens[i].type;
        let tokenFormat = tokens[i].format != undefined ? tokens[i].format : null;

        let tokenData = "\\[" + tokenName + "( default=\"([\\s\\w'À-ÿ\u00f1\u00d1&;]*)\")?\\]";
        const regexp = new RegExp(`${tokenData}`, "g");

        if (tokenFormat == 'url') {
          message = message.replace(regexp, function (match, group1, group2, index, original) {
            if (group2 == "") {
              return "<span class=\"token " + tokenType + "\"><a href=\"" + token + "\" target=\"_blank\">" + token + "</a></span>"
            } else {
              if (tokenName == 'my_calendar_link') {
                return "<span class=\"cursor-pointer\"><a  title=\"" + textTooltip + "\" style=\"color: blue; cursor: pointer\" href=\"#\" >" + group2 + "</a></span>"
              }
              return "<span class=\"token " + tokenType + "\"><a href=\"" + token + "\" target=\"_blank\">" + group2 + "</a></span>"
            }
          });
        } else {
          message = message.replace(regexp, "<span class=\"token " + tokenType + "\">" + token + "</span>");
        }
      }
      let contact = this.testBusinessContact[this.testBusinessContactSelected];

      let logo = this.currentUser.avatar;
      contact['[my_proposition]'] = "Ma proposition ici";
      contact['[my_website_url_tracking]'] = "https://aivoni.com";
      contact['[my_first_name]'] = "Thibault";
      contact['[my_last_name]'] = "Pons de Vincent"
      contact['[my_job_title]'] = "Sales representative"
      contact['[my_company_name]'] = "AiVONi";
      //contact['[my_calendar_link]'] = "https://google.com.ar";
      contact['[my_landing_page_link]'] = "https://aivoni.com/landing";
      contact['[my_unsubscribe_link]'] = "https://aivoni.com/unsubscribe";
      contact['[my_logo]'] = "<img src=\"" + logo + "\" alt=\"logo\" style=\"width:100px;\"/>";
      // La barra (\

      if (datatoken) {
        for (i = 0; i < tokens.length; i++) {
          if (datatoken[tokens[i].token] !== undefined && datatoken[tokens[i].token] !== null && datatoken[tokens[i].token] !== "") {
            contact[tokens[i].token] = datatoken[tokens[i].token];
          }
        }
      }

      if (this.campaignTokens !== undefined) {
        let campaignTokens = this.campaignTokens

        tokens.forEach(token => {
          let tokenData = token.token.replace("[", "").replace("]", "");
          if (campaignTokens[tokenData] !== undefined && campaignTokens[tokenData].value != token.token && campaignTokens[tokenData].value !== null) {
            contact[token.token] = campaignTokens[tokenData].value
          }
        });
      }

      for (const [key, value] of Object.entries(contact)) {
        let tokenData = key;
        tokenData = tokenData.replace('[', '\\[').replace(']', '\\]');
        const regexp = new RegExp(`(${tokenData})`, 'g')
        message = message.replace(regexp, value);
      }

      message = this.replaceSpintax(message);

      return message
    },

    changeBusinessContactSelected($val) {
      let newSelected = this.testBusinessContactSelected + $val;
      let maxCant = this.testBusinessContact.length - 1;
      if (this.testBusinessContactSelected == 0 && $val == '-1') {
        this.testBusinessContactSelected = maxCant;
      } else if (newSelected > maxCant) {
        this.testBusinessContactSelected = 0;
      } else {
        this.testBusinessContactSelected = newSelected;
      }
    },

    formatForCKEditor: function (message) {
      if (message != '') {

        let matchesNewLine = false;
        let regexpNewLine = "((\n)+(\r)*)+";
        regexpNewLine = new RegExp(`${regexpNewLine}`, 'g')
        matchesNewLine = message.match(regexpNewLine)
        if (matchesNewLine) {
          message = message.replace(regexpNewLine, "</p><p></p><p>");
        }

        let matches = message.match(/\[(\w+)\]/g)
        // console.log(matches);
        if (matches) {

          matches.forEach((value, key, map) => {
            if (value != "[my_website_url_tracking]" && value != "[my_proposition]") {
              //console.log({value});
              //console.log({key});
              //console.log({map});
              let token = value.replace("[", "").replace("]", "");
              value = value.replace("[", "\\[")
              value = value.replace("]", "\\]")

              let regexp = "^((?:(?:.*?" + value + "){0}.*?))" + value;
              regexp = new RegExp(`${regexp}`, 'g')

              let aphId = "autoplaceholder_" + this.generateRandomId();
              let span = "<span class=\"autoplaceholder\" placeholder=\"" + token + "\" id=\"" + aphId + "\" customid=\"" + aphId + "\" name=\"\" defaultvalue=\"\">";
              let replace = "$1" + span + "[" + token + " default=\"\"]</span>"

              // console.log(message.match(regexp))
              message = message.replace(regexp, replace);
            }
          });
        }
        if (matchesNewLine) {
          message = "<p>" + message + "</p>";
        }
      }

      return message;
    },
    generateRandomId: function () {
      return Math.floor((Math.random() * 1000000) + 1 + Date.now());
    },
    sendTestEmail() {
      if (this.model.campaign.conn_activated != 1) {
        if (this.model.campaign.user_id == this.currentUser.id) {
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.unlockyoursalesinboxadvanced"),
            text: this.$t("lang.label.youneedtosync2"),
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: this.$t("lang.button.connectmyemail"),
            cancelButtonColor: "#d33a2c",
          }).then((result) => {
            if (result.value) {
              this.$router.push({
                path: "/settings-account?synchronisation=1",
              });
            }
          });
        } else {
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.unlockyoursalesinboxadvanced"),
            text: this.$t("lang.label.youneedtosync3"),
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: this.$t("lang.button.ok"),
            cancelButtonColor: "#d33a2c",
          })
        }
        return false;
      }
      this.sendingTestEmail = true;
      emailsService
        .sendTestEmail(
          this.model,
          this.testBusinessContact[this.testBusinessContactSelected]
        )
        .then(
          (result) => {
            this.sendingTestEmail = false;
            this.$swal({
              type: "success",
              text: this.$t("lang.label.emailwassentsuccessfully"),
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: this.$t("lang.button.ok"),
              cancelButtonColor: "#d33a2c",
            })
          },
          (error) => {
            this.request = false;
            //if(error.message == )
            this.$swal({
              type: "error",
              text: error.message,
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: this.$t("lang.button.ok"),
              cancelButtonColor: "#d33a2c",
            })
          }
        );
    },
    isParameterTF(param_id) {
      if (this.model.parameters_tf.indexOf(param_id) !== -1) {
        return true;
      }
      return false;
    },
    setParameterTF(param_id, value) {
      if (value) {
        if (this.model.parameters_tf.indexOf(param_id) === -1) {
          this.model.parameters_tf.push(param_id);
        }
      } else {
        if (this.model.parameters_tf.indexOf(param_id) !== -1) {
          this.model.parameters_tf.splice(
            this.model.parameters_tf.indexOf(param_id),
            1
          );
        }
      }
    },

    filterTokens(token) {
      return (token.type != "agency" || (token.type == "agency" && (this.currentUser.is_agency == 1 || this.currentUser.role_id == 1)));
    },

    sentEmailKind(item) {
      if (item.type != "emailsent" && item.type != "emailsentopportunity") {
        return null;
      }
      const typeId = Number(item.email_sent_type_id);
      if (typeId === 4) {
        return "reminder";
      }
      if (typeId === 3) {
        return "reschedule";
      }
      if ([2, 5, 6, 7, 8, 9].includes(typeId)) {
        return "auto";
      }
      return "manual";
    },
  }
}
